import noty from '@/plugins/noty'

export const callEndedNotification = noty({
  type: 'info',
  timeout: 3000,
  text: 'The call has ended'
})



// WEBPACK FOOTER //
// ./src/components/live-coach-call/with-pusher-subscription/notifications.js